import { Download, FileCopy } from "@mui/icons-material";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, InputAdornment, TextField, Tooltip, Typography } from "@mui/material";
import { useAtom } from "jotai";
import { FC, useRef } from "react";
import QRCode from "react-qr-code";
import { modalQR } from "../../atoms/atom";
import { useUtils } from "../../utils/utilFunctions";
import './QrCodeModal.scss';

const QrCodeModal: FC<{ module: string; link: string }> = ({ module, link }) => {
	const [open, setOpen] = useAtom(modalQR);
	const qrRef = useRef<HTMLDivElement>(null);
	const { handleCopy } = useUtils();

	const close = () => {
		setOpen(false);
	}

	const handleDownload = () => {
		if (!qrRef.current) return;
		const svgElement = qrRef.current.querySelector('svg');
		if (!svgElement) return;
		const serializer = new XMLSerializer();
		const svgString = serializer.serializeToString(svgElement);
		const canvas = document.createElement('canvas');
		const ctx = canvas.getContext('2d');
		const img = new Image();
		img.onload = () => {
			canvas.width = img.width;
			canvas.height = img.height;
			if (ctx) {
				ctx.fillStyle = '#FFFFFF';
				ctx.fillRect(0, 0, canvas.width, canvas.height);
				ctx.drawImage(img, 0, 0);
			}
			const pngUrl = canvas.toDataURL('image/png');
			const downloadLink = document.createElement('a');
			downloadLink.href = pngUrl;
			downloadLink.download = 'qrcode.png';
			document.body.appendChild(downloadLink);
			downloadLink.click();
			document.body.removeChild(downloadLink);
		};
		img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgString)));
	};

	return (
		<Dialog
			open={open}
			onClose={() => close()}
			id='modal-qr'
		>
			<DialogTitle>QR Code</DialogTitle>
			<DialogContent id="modal-qr-content">
				<Typography textAlign="center" variant="h6">{`Escaneie o QR Code abaixo para acessar ${module}`}</Typography>
				<Box className="qr-code-container" ref={qrRef}>
					<QRCode value={link} id="qr-code" />
					<Button 
						variant="contained" 
						startIcon={<Download />} 
						onClick={handleDownload}
					>
						Baixar imagem do QR Code
					</Button>
				</Box>
				<Typography variant="h6">Ou acesse o link abaixo:</Typography>
				<TextField
					InputProps={{
						endAdornment: (
						<InputAdornment position="end">
							<Tooltip title="Copiar">
							<IconButton
								onClick={() => handleCopy(link)}
								edge="end"
							>
								<FileCopy />
							</IconButton>
							</Tooltip>
						</InputAdornment>
						)
					}}
					id="link-form"
					value={link}
					variant="standard"
				>
				</TextField>
			</DialogContent>
			<DialogActions>
				<Button id="close-form-qr-button" onClick={() => setOpen(false)}>
					Fechar
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default QrCodeModal;